import { http } from '@pendo/http';

export function startBillingProcess (billingDetails) {
    return http.post('/api/s/_SID_/billing/payment', billingDetails).then((res) => res.data);
}

export function getBillingStatus () {
    return http.get('/api/s/_SID_/billing/status', {
        bypassUnauthorizedLogout: true,
    });
}

export function getBillingContinue () {
    return http.get('/api/s/_SID_/billing/continue', {
        bypassUnauthorizedLogout: true,
    });
}

export function getBillingInfo () {
    return http.get('/api/s/_SID_/billing/info', {
        bypassUnauthorizedLogout: true,
    });
}

export function restartPaymentFlow () {
    return http.delete('/api/s/_SID_/billing/payment').then((res) => res.data);
}

export function fetchPaddleCountriesList () {
    return http.get('/api/s/_SID_/billing/countries').then((res) => res.data);
}

export const getPlanUpgradePreview = (planName, mau, returnUrl) => {
    return http
        .get('/api/s/_SID_/billing/plan/upgrade', { params: { planName, mau, returnUrl } })
        .then((res) => res.data);
};

export function upgradePlan ({ termsVersion }) {
    return http.post('/api/s/_SID_/billing/plan/upgrade', { termsVersion }).then((res) => res.data);
}
